import axios from "axios";
import { Constants } from "../utils/Constants";

export function getDataTable(events) {
    return axios.post(`${Constants.baseUrl}/solicitacao/list`, events);
}

export function create(form) {
    return axios.post(`${Constants.baseUrl}/solicitacao`, form);
}

export function destroy(id) {
    return axios.delete(`${Constants.baseUrl}/solicitacao/${id}`);
}

export function get(id) {
    return axios.get(`${Constants.baseUrl}/solicitacao/${id}`);
}

export function marcarResolvida(id) {
    return axios.get(`${Constants.baseUrl}/solicitacao/${id}/resolvida`);
}
